<template>
  <div class="w-100 h-100">
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div class="check-wrap">
        <div class="check-parts" style="color: #666">{{ checkList.length }}件を選択中</div>
        <div class="check-parts pointer" @click="report_id == 'demo' ? '' : deleteInfluencer()" :style="report_id == 'demo' ? 'opacity:0.5' : ''"><i class="el-icon-delete" style="font-size: 14px"></i>レポートから削除</div>
        <el-tooltip :disabled="checkList.length < 151 && ig_info != ''">
          <div slot="content">{{ ig_info == "" ? "Instagramアカウントが未連携です" : checkList.length > 150 ? "メッセージは150名以上には一斉送信できません" : "" }}</div>
          <span>
            <el-button type="primary" size="small" @click="newmessage_drawer = true" :disabled="checkList.length > 150 || newmessage_drawer || report_id == 'demo'">
              <font-awesome-icon :icon="['fas', 'paper-plane']" style="margin-right: 5px;" />メッセージ
            </el-button>
          </span>
        </el-tooltip>
      </div>
    </div>
    <div class="report-done-switch influencer">
      <div v-if="done_data && result_count >= 0" class="report-influencer-breadcrumb">
        <span class="report-influencer-breadcrumb-num">{{ result_count }}</span
        >名の投稿済みインフルエンサー /<span class="report-influencer-breadcrumb-num">{{ result_count_all }}</span
        >名中
      </div>
      <div v-else-if="result_count >= 0" class="report-influencer-breadcrumb">
        <span class="report-influencer-breadcrumb-num">{{ all_influencer.length }}</span
        >名のインフルエンサー
      </div>
      <div class="flex-space"></div>
      <reportDisplayButton :sns_type="'instagram'" :list_type="'influencer'"  />
      <el-dropdown trigger="click" style="margin-left: 20px">
        <el-button type="info" class="report-media-sort-button" style="width: auto">
          <span v-if="done_data"> <font-awesome-icon :icon="['far', 'user-check']" style="margin-right: 5px" />投稿済みのインフルエンサーのみ </span>
          <span v-else> <font-awesome-icon :icon="['far', 'user-friends']" style="margin-right: 5px" />全てのインフルエンサー </span>
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="done_data = false">全てのインフルエンサー</el-dropdown-item>
          <el-dropdown-item @click.native="done_data = true">投稿済みのインフルエンサーのみ</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="data-table-media-wrap">
      <table class="data-table-media">
        <tr v-if="!mounted" class="new-table-title w-100">
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width200"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
        </tr>
        <tr v-else class="new-table-title">
          <div class="new-table-item checkbox-all">
            <div class="checkbox_inner" :class="check_list_status" @click="checkAll('auto')"></div>
            <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
              <span style="height:20px">
                <div class="checkbox-select-wrap report" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="checkAll('select')">表示中を全て選択({{ influencer_list ? influencer_list.length : "-" }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselect')">表示中を全て選択解除({{ influencer_list ? influencer_list.length : "-" }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('selectAll')" divided>レポート内の投稿を全て選択({{ all_influencer.length }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselectAll')" v-if="checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div
            v-for="(column, column_index) in report_influencer_column"
            v-show="item[column.column]"
            :key="column.column"
            class="new-table-item"
            :class="[column.width, column_index == 0 ? 'title-sticky-influencer' : '', column_index < 2 ? 'nohover' : '']"
            @click="column_index > 1 && !['average_engagement_impression_rate', 'average_engagement_reach_rate'].includes(column.column) ? sortBy(column.column) : ''"
          >
            <span :class="[sort_key == column.column ? 'new-table-title-sort' : '', column_index == 0 ? 'new-table-title-0' : '']">
              {{ column.title }}
              <font-awesome-icon
                v-if="sort_key == column.column"
                :icon="['fas', sort_key == column.column && sort_order == 'asc' ? 'arrow-up' : sort_key == column.column && sort_order == 'desc' ? 'arrow-down' : '']"
                style="margin-left:3px;"
              />
            </span>
          </div>
        </tr>
        <!-- <tbody>
          <tr class="new-table-content total">
            <div class="new-table-item checkbox">

            </div>
            <reportInfluencerValue
              v-for="(column, column_index) in column_list"
              v-show="item[column.column]"
              class="new-table-item nohover"
              :class="[column.width, column_index == 0 ? 'sticky' : '']"
              :key="column.column"
              :column="column.column"
              :report_id="report_id"
              :index="row_index"
              :value="report[column.column]"
              :type="column.type"
            />
          </tr>
        </tbody> -->
        <!-- <tbody> -->
        <tr class="new-table-content influencer" v-for="(influencer, row_index) in influencer_list" :key="influencer.ig_id">
          <div class="new-table-item checkbox">
            <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.ig_id" :id="influencer.ig_id + 'checkbox'" />
            <label class="checkbox_inner" :for="influencer.ig_id + 'checkbox'"> </label>
          </div>
          <reportInfluencerValue
            v-for="(column, column_index) in report_influencer_column"
            v-show="item[column.column]"
            class="new-table-item nohover"
            :class="[column.width, column_index == 0 ? 'sticky' : '']"
            :key="column.column"
            :column="column.column"
            :report_id="report_id"
            :ig_id="influencer['ig_id']"
            :index="row_index"
            :value="influencer[column.column]"
            :type="column.type"
            @openMedia="openMedia"
            @storiesReactive="storiesReactive"
          />
        </tr>
        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <!-- </tbody> -->
      </table>
    </div>

    <reportPostDrawer
      v-if="mounted && !loading"
      :report_id="report_id"
      :post_list="post_list"
      :influencer="influencer_info"
      :post_drawer="post_drawer"
      @closeMedia="closeMedia"
      @openInfluencer="openInfluencer"
    />

    <!-- 新規メッセージ作成 -->
    <transition name="fade">
      <newmessage
        v-if="newmessage_drawer"
        :newmessage_drawer="newmessage_drawer"
        :recipient="checkListDetail"
        :checkList.sync="checkList"
        :html.sync="html"
        @closeNewmessage="newmessage_drawer = false"
        @clearList="checkList = []"
      />
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadReportInfluencerAPI = root + "/api/report/load_report_influencer";
const deleteInfluencerAPI = root + "/api/report/delete_influencer";
// const deletePostAPI = root + "/api/report/delete_post";

import reportInfluencerValue from "./report_influencer_value.vue";
import reportPostDrawer from "./report_post_drawer.vue";
import reportDisplayButton from "./report_display_button.vue";
import newmessage from "../message/newmessage.vue";
// import costSetting from "./cost_setting.vue";

export default {
  name: "reportInfluencer",
  props: ["report_id"],
  components: {
    reportInfluencerValue,
    reportPostDrawer,
    reportDisplayButton,
    newmessage,
    // costSetting,
  },
  data() {
    return {
      // report_id: 820, //仮 後でpropsに置き換え
      sns_type: "instagram",
      mounted: false,
      loading: false,
      checkList: [],
      checkListDetail: [],
      checkAll_dropdown: false,
      all_influencer: [],
      influencer_list: [],
      column_list: [],
      infiniteId: +new Date(),
      requestId: +new Date(),
      count: 0,
      sort_key: "followers_count",
      sort_order: "desc",
      result_count: -1,
      result_count_all: -1,
      nodata: false,
      done_data: true,
      post_drawer: false,
      post_list: [],
      influencer_info: [],
      influencer_drawer: false,
      newmessage_drawer: false,
      html: "",
      for_dm: [],
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    active_cell() {
      return this.row_index + "-" + this.column_index;
    },
    check_list_status() {
      if (this.influencer_list.length > 0) {
        var checkCount = 0;
        for (let i = 0; i < this.influencer_list.length; i++) {
          for (let ii = 0; ii < this.checkList.length; ii++) {
            if (this.influencer_list[i].ig_id == this.checkList[ii]) checkCount += 1;
          }
        }
        if (checkCount == this.influencer_list.length) {
          return "all";
        } else if (checkCount > 0) {
          return "some";
        } else {
          return "none";
        }
      } else {
        return "none";
      }
    },
    item() {
      return this.$store.state.report_item;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    sessionid() {
      if (this.$store.state.ig_info) {
        return this.$store.state.ig_info.sessionid;
      } else {
        return null;
      }
    },
    // インフルエンサーリストには不要なカラムを非表示
    report_influencer_column() {
      return this.column_list.filter(function (column_list) {

        let nodisplay_column = [
          "average_engagement_diff",
          "average_engagement_only_pr_diff",
          "average_like_diff",
          "average_comments_diff"
        ];

        return !nodisplay_column.includes(column_list.column)
      })
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.infiniteHandler();
    });
  },
  methods: {
    infiniteHandler($state) {
      this.nodata = false;
      this.loading = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("report_id", this.report_id == "demo" ? 1 : this.report_id);
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("token", this.report_id == "demo" ? "demo" : this.token);
      params.append("done", this.done_data);
      params.append("user_token", this.user_token);
      this.axios
        .post(loadReportInfluencerAPI, params, { requestId: this.requestId })
        .then((response) => {
          this.cancelSource = null;
          if (this.count == 0) {
            this.result_count = response.data.result_count;
            this.result_count_all = response.data.result_count_all;
            this.column_list = response.data.column_list;
            this.influencer_list = response.data.influencer_list;
            this.all_influencer = response.data.all_influencer;
            this.for_dm = response.data.for_dm
            this.count += 20;
            $state.loaded();
          } else {
            this.influencer_list = this.influencer_list.concat(response.data.influencer_list);
            this.count += 20;
            $state.loaded();
          }
          if (this.count >= this.result_count) $state.complete();
          if (this.result_count == 0) this.nodata = true;
          this.loading = false;
          this.mounted = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reload() {
      this.count = 0;
      this.loading = true;
      this.influencer_list = [];
      this.checkList = [];
      this.infiniteId += 1;
    },
    sortBy(sort_key) {
      if (this.sort_key == sort_key) {
        this.sort_order = this.sort_order == "desc" ? "asc" : "desc";
      } else {
        this.sort_key = sort_key;
        this.sort_order = "desc";
      }
      this.reload();
    },
    checkAll(type) {
      if (type == "auto") {
        if (this.check_list_status == "all") type = "unselect";
        if (this.check_list_status == "some") type = "unselect";
        if (this.check_list_status == "none") type = "select";
      }
      if (type == "select") {
        for (let i = 0; i < this.influencer_list.length; i++) {
          if (!this.checkList.includes(this.influencer_list[i].ig_id)) this.checkList.push(this.influencer_list[i].ig_id);
        }
      } else if (type == "unselect") {
        for (let i = 0; i < this.influencer_list.length; i++) {
          if (this.checkList.includes(this.influencer_list[i].ig_id)) {
            var index = this.checkList.indexOf(this.influencer_list[i].ig_id);
            this.checkList.splice(index, 1);
          }
        }
      } else if (type == "selectAll") {
        this.checkList = [];
        this.checkList = this.checkList.concat(this.all_influencer);
      } else if (type == "unselectAll") {
        this.checkList = [];
      }
    },
    deleteInfluencer() {
      const num = this.checkList.length;
      const h = this.$createElement;
      this.$msgbox({
        title: "インフルエンサー削除",
        type: "warning",
        message: h("p", null, [h("span", null, "レポートからインフルエンサーを削除しますか？"), h("br", null, ""), h("span", null, "この作業は取り消せません")]),
        showCancelButton: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("report_id", this.report_id);
        params.append("sns_type", this.sns_type);
        params.append("influencer", JSON.stringify(this.checkList));
        params.append("token", this.token);
        this.axios.post(deleteInfluencerAPI, params).then(() => {
          this.reload();
          this.$emit("loadReportDetail")
          this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", num + "名のインフルエンサーをレポートから削除しました", {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "success",
          });
          this.checkList = [];
          this.checkAll_val = false;
        });
      });
    },
    openMedia(index) {
      this.post_list = this.influencer_list[index].influencer.post_list;
      this.influencer_info = this.influencer_list[index].influencer;
      if (this.post_list.length){
      this.post_drawer = true;
      } else {
        this.$message({
          message: "投稿がありません",
          type: "error",
          offset: 7,
        });
      }
    },
    closeMedia() {
      // this.media_index = -1;
      this.post_drawer = false;
    },
    openInfluencer(account_name) {
      this.$emit("openInfluencer", account_name);
    },
    storiesReactive(index){
      this.influencer_list[index].influencer.stories = !this.influencer_list[index].influencer.stories;
    }
  },
  watch: {
    done_data() {
      this.reload();
    },
    checkList() {
      this.checkListDetail = [];
      for (let i = 0; i < this.checkList.length; i++) {
        var ig_id = this.checkList[i];
        var detail = {
          account_name: this.for_dm[ig_id].account_name,
          ig_id: this.for_dm[ig_id].ig_id,
          name: this.for_dm[ig_id].name,
          profile_picture_url: this.s3BaseUrl + "/profile_picture/" + this.for_dm[ig_id].account_name + ".jpg",
          badge: this.for_dm[ig_id].badge,
        };
        this.checkListDetail.unshift(detail);
        if (i >= 149) break;
      }
      this.checkListDetail = this.checkListDetail.reverse();
    },
  },
  filters: {},
};
</script>
